import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import UpdateStatementDTO from '../models/statement/UpdateStatementDTO';
import GalaxyPortfolioDTO from '../models/statement/GalaxyPortfolioDTO';
import CollectionDTO from '../models/generic/CollectionDTO';
import StudentStatementDTO from '../models/statement/StudentStatementDTO';
import TableResponseDTO from '../models/datatable/TableResponseDTO';
import StatementDTO from '../models/statement/StatementDTO';
import StatementDropdownDTO from '../models/statement/StatementDropdownDTO';
import AddStatementDTO from '../models/statement/AddStatementDTO';
import TableRequestDTO from '../models/datatable/TableRequestDTO';

export class StatementApiController {
    // post: Statement/AddStatement
    public RouteAddStatement = () => `Statement/AddStatement`;
    public addStatement(addStatementDTO: AddStatementDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteAddStatement();
        return HttpApi.RestRequest<any, void>(addStatementDTO, 'post', url, requestOptions);
    }
    // post: Statement/UpdateStatement
    public RouteUpdateStatement = () => `Statement/UpdateStatement`;
    public updateStatement(updateStatementDTO: UpdateStatementDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteUpdateStatement();
        return HttpApi.RestRequest<any, void>(updateStatementDTO, 'post', url, requestOptions);
    }
    // get: Statement/AdminUpdateStudentStatementCompletion/${statementId}/${userId}/${gradeId}
    public RouteAdminUpdateStudentStatementCompletion = (statementId: number, userId: number, gradeId: number) => `Statement/AdminUpdateStudentStatementCompletion/${statementId}/${userId}/${gradeId}`;
    public adminUpdateStudentStatementCompletion(statementId: number, userId: number, gradeId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteAdminUpdateStudentStatementCompletion(statementId, userId, gradeId);
        return HttpApi.RestRequest<any, void>(null, 'get', url, requestOptions);
    }
    // post: Statement/UpdateStudentStatement
    public RouteUpdateStudentStatement = () => `Statement/UpdateStudentStatement`;
    public updateStudentStatement(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteUpdateStudentStatement();
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
    // get: Statement/GetStatement/${statementId}
    public RouteGetStatement = (statementId: number) => `Statement/GetStatement/${statementId}`;
    public getStatement(statementId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<UpdateStatementDTO>> {
        let url = this.RouteGetStatement(statementId);
        return HttpApi.RestRequest<any, UpdateStatementDTO>(null, 'get', url, requestOptions);
    }
    // get: Statement/GetAllStudentIStatements
    public RouteGetAllStudentIStatements = () => `Statement/GetAllStudentIStatements`;
    public getAllStudentIStatements(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<CollectionDTO<GalaxyPortfolioDTO>>> {
        let url = this.RouteGetAllStudentIStatements();
        return HttpApi.RestRequest<any, CollectionDTO<GalaxyPortfolioDTO>>(null, 'get', url, requestOptions);
    }
    // get: Statement/GetStudentIStatements
    public RouteGetStudentIStatements = () => `Statement/GetStudentIStatements`;
    public getStudentIStatements(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<CollectionDTO<StudentStatementDTO>>> {
        let url = this.RouteGetStudentIStatements();
        return HttpApi.RestRequest<any, CollectionDTO<StudentStatementDTO>>(null, 'get', url, requestOptions);
    }
    // post: Statement/GetStudentStatementTableData/${userId}
    public RouteGetStudentStatementTableData = (userId: number) => `Statement/GetStudentStatementTableData/${userId}`;
    public getStudentStatementTableData(tableRequest: TableRequestDTO, userId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<StudentStatementDTO>>> {
        let url = this.RouteGetStudentStatementTableData(userId);
        return HttpApi.RestRequest<any, TableResponseDTO<StudentStatementDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // post: Statement/GetStatementTableData
    public RouteGetStatementTableData = () => `Statement/GetStatementTableData`;
    public getStatementTableData(tableRequest: TableRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<StatementDTO>>> {
        let url = this.RouteGetStatementTableData();
        return HttpApi.RestRequest<any, TableResponseDTO<StatementDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // get: Statement/GetStatementsForAcademicStandard
    public RouteGetStatementsForAcademicStandard = () => `Statement/GetStatementsForAcademicStandard`;
    public getStatementsForAcademicStandard(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<StatementDropdownDTO[]>> {
        let url = this.RouteGetStatementsForAcademicStandard();
        return HttpApi.RestRequest<any, StatementDropdownDTO[]>(null, 'get', url, requestOptions);
    }
    // post: Statement/CopyKuderGenericIStatements
    public RouteCopyKuderGenericIStatements = () => `Statement/CopyKuderGenericIStatements`;
    public copyKuderGenericIStatements(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteCopyKuderGenericIStatements();
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
    // post: Statement/SoftDeleteStatement?statementId=${statementId}
    public RouteSoftDeleteStatement = (statementId: number) => `Statement/SoftDeleteStatement?statementId=${statementId}`;
    public softDeleteStatement(statementId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteSoftDeleteStatement(statementId);
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
}
var service = new StatementApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/StatementApiController.ts